import moment from "moment";
import { isEmpty } from "lodash";
import { MONTHS_OF_YEAR, DAYS_OF_WEEK } from "../../constants";

const createEmptyRule = () => ({
  /**
   * @returns an Empty rule object.
   */

  startTime: "",
  endTime: "",
  week_days: [],
  month_days: [],
  months: [],
});

const monthsOfYear = MONTHS_OF_YEAR.map((month) => month.toLocaleLowerCase());
const weekday = DAYS_OF_WEEK.map((daysOfWeek) => daysOfWeek.toLocaleLowerCase());

const splitBreaker = (timeSpan) => {
  /**
   * @param {Array} timeSpan an array of timeSpan objects
   * @returns                an array of formatted dayTime objects.
   */
  const monthDays = [];
  const months = [];
  const daysOfWeek = [];

  const startTime = moment.utc(`${timeSpan.startTime}`, "YYYY-MM-DDT HH:mm").toISOString();
  const endTime = moment.utc(`${timeSpan.endTime}`, "YYYY-MM-DDT HH:mm").toISOString();

  monthDays.push(Number(startTime.slice(8, 10)));
  monthDays.push(Number(endTime.slice(8, 10)));
  months.push(monthsOfYear[Number(startTime.slice(5, 7)) - 1]);
  months.push(monthsOfYear[Number(endTime.slice(5, 7)) - 1]);
  daysOfWeek.push(weekday[moment.utc(startTime).day()]);
  daysOfWeek.push(weekday[moment.utc(endTime).day()]);

  return {
    startTime: timeSpan.startTime.slice(11, 16),
    endTime: timeSpan.endTime.slice(11, 16),
    week_days: [...new Set(daysOfWeek)],
    month_days: [...new Set(monthDays)],
    months: [...new Set(months)],
  };
};

export default (daySpanObject) => {
  /**
   * @param {Object(<scheduleName: String, rules: Array[]>)}  daySpanObject an array of ISO dateTime objects.
   *
   * @returns {Object(<scheduleName: String, rules: Array[])}        an object with rules spread across start and end times.
   */

  if (isEmpty(daySpanObject)) {
    return null;
  }

  const rules = [];

  const daySpanList = daySpanObject.daySpanList;
  const scheduleName = daySpanObject.scheduleName;

  if (daySpanList.length < 1) {
    return {
      scheduleName,
      rules,
    };
  }

  let splitRule = splitBreaker(daySpanList[0]);
  let newRule = createEmptyRule();

  newRule.startTime = splitRule.startTime;
  newRule.endTime = splitRule.endTime;
  newRule.week_days = splitRule.week_days;
  newRule.month_days = [];
  newRule.months = splitRule.months;
  rules.push(newRule);

  for (let i = 1; i < daySpanList.length; i++) {
    const currentSplit = daySpanList[i];
    splitRule = splitBreaker(currentSplit);

    // get the last rule object in the array:
    const lastRule = rules[rules.length - 1];
    if (
      lastRule.startTime === splitRule.startTime &&
      lastRule.endTime === splitRule.endTime &&
      lastRule.months[0] === splitRule.months[0]
    ) {
      lastRule.month_days = [];
      lastRule.week_days = [...new Set([...lastRule.week_days, ...splitRule.week_days])];
      rules[rules.length - 1] = lastRule;
    } else {
      newRule = createEmptyRule();
      newRule.startTime = splitRule.startTime;
      newRule.endTime = splitRule.endTime;
      newRule.week_days = splitRule.week_days;
      newRule.month_days = [];
      newRule.months = splitRule.months;
      rules.push(newRule);
    }
  }

  return {
    scheduleName,
    rules,
  };
};
